export default {"src":"/_next/static/media/info.b9f35578.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};